import LegalLayout from "./LegalLayout";

export default function PrivacyPage() {
  return (
    <LegalLayout title="Privacy Policy">
      <p>
        VEE Consultancy ("we", "our") respects your privacy. This Privacy Policy explains how we collect, use, and protect your personal information when you register for our Masterclass / Webinar or interact with our website.
      </p>

      <h2 className="text-2xl font-bold mt-10 mb-3">1. Information We Collect</h2>
      <ul className="list-disc pl-6 space-y-2">
        <li><strong>Registration details:</strong> your full name, email address, and WhatsApp number.</li>
        <li><strong>Optional details:</strong> your trading experience level (Beginner / Intermediate / Advanced).</li>
        <li><strong>Technical data:</strong> basic browser/device information via standard web logs.</li>
      </ul>

      <h2 className="text-2xl font-bold mt-10 mb-3">2. How We Use Your Information</h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>To confirm your webinar registration and send reminders via WhatsApp and email.</li>
        <li>To share webinar links, session recordings (if applicable), and related educational updates.</li>
        <li>To occasionally inform you about future free webinars, market education content, or offerings by VEE Consultancy.</li>
        <li>To respond to your queries and improve our services.</li>
      </ul>

      <h2 className="text-2xl font-bold mt-10 mb-3">3. Data Sharing</h2>
      <p>
        We do <strong>not sell, rent, or trade</strong> your personal information to third parties. Your data may be processed by trusted service providers (e.g., WhatsApp messaging partner, email service, website hosting) solely to deliver the services you signed up for.
      </p>

      <h2 className="text-2xl font-bold mt-10 mb-3">4. Data Security</h2>
      <p>
        We apply reasonable administrative and technical safeguards to protect your information. However, no system is 100% secure — by using this website, you acknowledge that data transmission over the internet carries inherent risks.
      </p>

      <h2 className="text-2xl font-bold mt-10 mb-3">5. Your Rights</h2>
      <p>
        You may at any time:
      </p>
      <ul className="list-disc pl-6 space-y-2">
        <li>Request access to the personal data we hold about you.</li>
        <li>Request correction or deletion of your data.</li>
        <li>Opt out of marketing communication (reply <em>STOP</em> on WhatsApp or unsubscribe from emails).</li>
      </ul>
      <p>
        To exercise any of these rights, please <a href="/contact">contact us</a>.
      </p>

      <h2 className="text-2xl font-bold mt-10 mb-3">6. Cookies</h2>
      <p>
        This website may use minimal cookies for analytics and performance. You can disable cookies through your browser settings.
      </p>

      <h2 className="text-2xl font-bold mt-10 mb-3">7. Third-Party Disclaimer</h2>
      <p>
        This website is <strong>not affiliated with, endorsed by, or sponsored by Meta (Facebook / Instagram) or Google</strong>. These names are trademarks of their respective owners.
      </p>

      <h2 className="text-2xl font-bold mt-10 mb-3">8. Policy Updates</h2>
      <p>
        We may update this Privacy Policy periodically. The "Last updated" date at the bottom of this page reflects the most recent revision.
      </p>
    </LegalLayout>
  );
}
